import { Any } from '@common/defs/types';

const Routes: Any = {
  Settings: {
    Prefix: '/parametres',
  },
};
Routes.Settings = {
  ...Routes.Settings,
  MyAccount: `${Routes.Settings.Prefix}/compte`,
  OpeningTimes: `${Routes.Settings.Prefix}/horaires-ouverture`,
  Office: `${Routes.Settings.Prefix}/cabinet`,
  Preferences: `${Routes.Settings.Prefix}/preferences`,
  Billing: `${Routes.Settings.Prefix}/facturation`,
  Subscription: `${Routes.Settings.Prefix}/ma-formule`,
};

export default Routes;
